import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {VehiclesComponent} from './vehicles/vehicles.component';
import {NotFoundComponent} from "./not-found/not-found.component";
import {VehicleSliceComponent} from "./vehicleslice/vehicle-slice.component"

const routes: Routes = [
	{
		path: 'finance/payment-calculator',
		component: VehiclesComponent

	},
	{
		path: 'finance/payment-calculator',
		redirectTo: '/finance/payment-calculator/',
		pathMatch: 'full'

	},
	{
		path: 'finance/payment-calculator/:make/:modelname/:year',
		component: VehicleSliceComponent,
	},
	{
		path: '',
		redirectTo: '/finance/payment-calculator',
		pathMatch: 'full'
	},
	{
		path: '404', component: NotFoundComponent
	},
	{
		path: '**', redirectTo: '/404'
	}
];
@NgModule({
	imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
